export const ATTACHMENTS_TOOLBAR_KEY = 'ATTACHMENTS_TOOLBAR';

export const ATTACHMENTS_TOOLBAR_KEY_EVENT = `${ATTACHMENTS_TOOLBAR_KEY}:EVENT`;

export const ATTACHMENTS_TOOLBAR_KEY_UPDATE_EVENT = `${ATTACHMENTS_TOOLBAR_KEY}:UPDATE_EVENT`;

export const ATTACHMENTS_TOOLBAR_ACTION = {
  ADD: `${ATTACHMENTS_TOOLBAR_KEY}:ADD`,
  ADD_MANY: `${ATTACHMENTS_TOOLBAR_KEY}:ADD_MANY`,
  UPDATE: `${ATTACHMENTS_TOOLBAR_KEY}:UPDATE`,
  UPDATE_MANY: `${ATTACHMENTS_TOOLBAR_KEY}:UPDATE_MANY`,
  UPDATE_STATUS: `${ATTACHMENTS_TOOLBAR_KEY}:UPDATE_STATUS`,
  UPDATE_STATUS_MANY: `${ATTACHMENTS_TOOLBAR_KEY}:UPDATE_STATUS_MANY`,
  UPDATE_PROGRESS: `${ATTACHMENTS_TOOLBAR_KEY}:UPDATE_PROGRESS`,
  REMOVE: `${ATTACHMENTS_TOOLBAR_KEY}:REMOVE`,
  REMOVE_ALL: `${ATTACHMENTS_TOOLBAR_KEY}:REMOVE_ALL`,
} as const;
